export const ROUTE_PARAMS_REGEX: RegExp = /:[a-z]+/gi;
export const EMAIL_REGEX: RegExp = /^[^\s]+@[^\s]+\.[^\s]+$/i;
